console.log('🔥 CUSTOM JS VERSION 7 LOADED 🔥');


// Custom: Force external menu links to open in new tab
  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="http"]');
    links.forEach(link => {
      if (link.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  });

 // Hover dropdowns on desktop: Seamless open/close with no gap flicker or overlap
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 749) return; // Skip on mobile

  const menuItems = document.querySelectorAll('.header__inline-menu details');

  menuItems.forEach(item => {
    // Open on hover over parent
    item.addEventListener('mouseover', () => {
      item.setAttribute('open', true);
    });

    // Close when leaving the entire item (parent + submenu)
    item.addEventListener('mouseout', (e) => {
      // Only close if mouse is truly leaving the whole <details> (not moving to child submenu)
      if (!item.contains(e.relatedTarget)) {
        item.removeAttribute('open');
      }
    });
  });
});

// Rubik app - hide thumbnails if there is only one thumbnail
// Hide thumbnail strip when only one thumbnail is visible (single-image variants)
function toggleThumbnails() {
  const thumbnailSlider = document.querySelector('slider-component.thumbnail-slider');
  if (!thumbnailSlider) return;

  const visibleThumbnails = thumbnailSlider.querySelectorAll(
    '.thumbnail-list__item:not([style*="display: none"])'
  );

  thumbnailSlider.style.visibility = visibleThumbnails.length <= 1 ? 'hidden' : '';
}

document.addEventListener('DOMContentLoaded', toggleThumbnails);

const galleryThumbnails = document.querySelector('.thumbnail-list');
if (galleryThumbnails) {
  new MutationObserver(toggleThumbnails).observe(galleryThumbnails, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style']
  });
}